<template>
  <td :class="getIkoClass(currentItem[variableColor])" :title="getIkoText(currentItem[variableColor])">
    <template v-if="currentItem[variableValue] != null">
      {{ currentItem[variableValue] }}
    </template>
    <template v-else>
      <span class="color-transparent">-</span>
    </template>
  </td>
</template>

<script>
export default {
  name: "KoIKOTableColumn",
  props: {
    stationId: {
      type: Number,
    },
    ikoData: {
      type: Array,
    },
    variableColor: {
      type: String,
    },
    variableValue: {
      type: String,
    },

  },
  computed: {
    currentItem() {
      const self = this;
      if (self.ikoData.length) {
        let stationData = self.ikoData.find((item) => parseInt(item.station_id) === self.stationId);
        if (stationData) {
          return stationData.data;
        }
        return {}

      }

    }

  },

  methods: {
    getIkoText(val) {
      if (val === 1) return 'Dobrá';
      else if (val === 2) return 'Zhoršená';
      else if (val === 3) return 'Zlá';
      else return '';

    },
    getIkoClass(val) {
      if (val === 1) return 'oko_0';
      else if (val === 2) return 'oko_3';
      else if (val === 3) return 'oko_4';
      else return 'oko_null';
    }
  }
}
</script>

<style lang="scss">
/*
.iko-level-1 {
  background-color: #efefef !important;
  color: #000;
}

.iko-level-1 {
  background-color: #92d050  !important;
  color: #000;
}
.iko-level-2 {
  background-color: #ffc000  !important;
  color: #000;
}
.iko-level-3 {
  background-color: #ff0000 !important;
  color: #fff;
}

.color-transparent {
  color: transparent !important;
}
*/

</style>
